// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppProvider } from './contexts/AppContext';

// if (process.env.NODE_ENV === 'production') {
//   console.log = () => {};
//   console.info = () => {};
//   console.debug = () => {};
//   // Keep warnings and errors if you want
//   // console.warn = () => {};
//   // console.error = () => {};
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);